import { fetchRequest } from "@providers/conect";

const createMedicoApi = async (data) => {
  try {
    const url = `medicos/create`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const updateMedicoApi = async (id, data) => {
  try {
    const url = `medicos/update/${id}`;
    const response = await fetchRequest(url, {
      method: "PUT",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const updateMedicoSpecialtiesApi = async (id, specialtyIds) => {
  try {
    const url = `medicos/update-specialties/${id}`;
    const response = await fetchRequest(url, {
      method: "PUT",
      body: { specialtyIds }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const viewMedicosApi = async (data) => {
  try {
    const url = `medicos/view`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllMedicosApi = async () => {
  try {
    const url = `medicos/all`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteMedicoApi = async (id) => {
  try {
    const url = `medicos/delete/${id}`;
    const response = await fetchRequest(url, {
      method: "DELETE"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const uploadMedicoPhotoApi = async (data) => {
  try {
    const url = `medicos/upload-photo`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getMedicosBySpecialtyApi = async (idEsp) => {
  try {
    const url = `medicos/by-specialty/${idEsp}`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export {
  createMedicoApi,
  updateMedicoApi,
  updateMedicoSpecialtiesApi,
  viewMedicosApi,
  getAllMedicosApi,
  deleteMedicoApi,
  uploadMedicoPhotoApi,
  getMedicosBySpecialtyApi
};

// Inserción básica si no existe, usando campos mínimos
const createMedicoBasicIfMissingApi = async (data) => {
  try {
    const url = `medicos/create-basic-if-missing`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { createMedicoBasicIfMissingApi };

// Detalles de médico por cédula (iden)
const getMedicoDetailsByIdenApi = async (iden) => {
  try {
    const url = `medicos/details-by-iden/${encodeURIComponent(iden)}`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { getMedicoDetailsByIdenApi };

// Resumen de programación extra: pendientes/programados y total (num.medicos)
const getMedicosProgramacionResumenApi = async () => {
  try {
    const url = `medicos/programacion-resumen`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { getMedicosProgramacionResumenApi };